/** Helpers of the prices screen. */
import type { DmsItem } from '../api';

/** The upper-cased keys of the first price (the currencies). */
export const priceColumns = (prices: readonly DmsItem[]): string[] => {
  const first = prices[0];
  if (!first) return [];
  return Object.keys(first.data).filter((col) => col.toUpperCase() === col);
};

/** The number of `data` keys of the first price, frozen once loaded. */
export const priceColumnCount = (prices: readonly DmsItem[]): number =>
  prices[0] ? Object.keys(prices[0].data).length : 0;

/** One price per CSV row, the row as-is. */
export const csvRowsToPrices = (
  rows: readonly Record<string, unknown>[],
): { type: 'price'; data: Record<string, unknown> }[] =>
  rows.map((row) => ({ type: 'price' as const, data: { ...row } }));

export const priceCsvFileName = (now: Date): string => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `prices-${pad(now.getDate())}${pad(now.getMonth() + 1)}${now.getFullYear()}.csv`;
};
